<template>
    <div class="nbr-chart classic">
        <div v-if="title" class="title mg-title">
            <span v-html="title"></span>
            <span class="sub-title" v-if="subTitle" v-html="subTitle"></span>
        </div>
        <div class="empty-data" v-show="empty">
            <site-img
                src="//cdn.chime.me/image/fs01/agnentinfo/20180305/22/original_5294514866269879.png"
            ></site-img>
            <p class="text">Coming Soon</p>
        </div>
        <echart
            class="chart-box"
            :initOptions="initOptions"
            :options="options"
            @update="update"
        ></echart>
    </div>
</template>

<script>
import common from './common.js';
export default {
    mixins: [common]
};
</script>

<style lang="scss">
@import '../../theme/media.scss';
.nbr-chart.classic {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    position: relative;
    .title {
        padding-bottom: 20px;
        line-height: 1.2;
        .sub-title {
            color: #a0a0a0;
            margin-left: 6px;
        }
    }
    .empty-data {
        z-index: 1;
        position: absolute;
        max-width: 50%;
        width: 219px;
        height: auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        img {
            width: 100%;
        }
        .text {
            text-align: center;
            margin-top: 15px;
            color: #c8c8c8;
        }
    }
    .chart-box {
        width: 100%;
        flex: 1;
        z-index: 1;
    }
}
</style>
